import React from 'react';
import { View, Text } from 'react-native';

import Link from 'gatsby-link';
const ar_logo = '../fosol_ar_logo.svg';
const en_logo = '../fosol_en_logo.svg';

const styles = {
  holder: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 120,
    justifyContent: 'space-between'
  },
  list: {
    flexDirection: 'row'
  },
  dots: {
    marginHorizontal: 20,
    color: '#BBB'
  },
  links: {
    color: '#aaa',
    textDecoration: 'none',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#ddd',
    padding: '0 2px 5px 2px'
  }
};

const Footer = ({ lang, page }) => (
  <View style={styles.holder}>
    <Link
      style={{
        color: '#999',
        textDecoration: 'none'
      }}
      to={`/${lang.CODE}/`}
    >
      <Text className={`icon-fosol_${lang.CODE}_logo`} style={{ fontSize: 120, color: '#578bc1' }} />
    </Link>

    <Link style={styles.links} to={`/${lang.ALT_CODE}/${page.toLowerCase()}`}>
      {lang.ALT_LANG}
    </Link>
  </View>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/comp/header.js